module.exports = __webpack_public_path__ + "aba5d17e125ca3bbde9f735b9ba02e44.svg";